export namespace Information {
    export const EmailToHumane = {
        email: 'humane@ias.org.br',
        subject: 'Interesse em aplicar Realizando Escolhas',
    };
}
